import React from 'react';

const SignUpDesktop = () => {
  const handleSignUpClick = () => {
    const userType = 'NO_HOST';
    const url = `https://www.hightable.ai/tables-curated-just-for-you?user_type=${userType}`;
    window.location.href = url;
  };

  return (
    <div
      style={{ cursor: 'pointer' }}
      onClick={(e) => {
        e.preventDefault();
        handleSignUpClick();
      }}

      className="button-2 nav sidepas w-button"
    >
      <div>SIGNUP</div>
    </div>
  );
};

export default  SignUpDesktop;
